
import functions from '@/util/functions';
/**
 * 按题目随机
 * @param quesList 试题list
 * @param list 抽题条件list
 * @return Array
 */
export const randomType4 = (questionsList, list) => {
    let result = [], // 最后返回的结果
    quesSumList = [], // 按分页分开的试题id
    quesList = []
    questionsList.forEach((info, index) => {
        if (info.questionsTypeId != '26' ) {
            quesList.push(info)
        } else if (index != 0) {
            quesSumList.push(quesList)
            quesList = []
        }
        if (index == questionsList.length - 1) {
            quesSumList.push(quesList)
        }
        return info.questionsTypeId == '26'
    })
    list.forEach((info, index) => {
        if (!info.isRandom) {
            result = [...result, ...quesSumList[index]]
        } else if (info.isRandom && !info.isShowOnlyPart) {
            result = [...result ,...functions.GetArrDisorder(quesSumList[index])]
        } else if (info.isRandom && info.isShowOnlyPart) {
            result = [...result ,...functions.GetRandomArray(quesSumList[index], info.showSum)]
        }
    })
    return result
}